export { default } from './EnterpriseBadge';
